import {SERVER_URLS} from '@env/baseURL';
import * as packageJson from 'package.json';

const packageVersion = JSON.stringify(packageJson);

export const environment = {
  apiPort: 0, // DOCS: Puerto de la API
  apiUrl: SERVER_URLS.pqNet2ApiDev, // DOCS: URL de la API
  appName: 'ProquifaNet 2 R5 Cloudflare', // DOCS: Nombre de la aplicación en el browser
  appVersion: JSON.parse(packageVersion)?.version, // DOCS: Versión de la aplicación
  environmentServerName: 'dev-r5', // DOCS: Nombre del entorno
  i18nPrefix: '', // DOCS: Prefijo de i18n para las traducciones
  identityPort: 9001, // DOCS: Puerto de la API del identity
  identityUrl: SERVER_URLS.pqNet2IdentityDev, // DOCS: URL de la API del identity
  production: false, // DOCS: Activa el modo de producción
};
